<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.author" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>
      <div v-if="record.executor">Представитель подрядчика: {{ record.executor.fullName }}</div>
      <div v-if="record.client">Представитель заказчика: {{ record.client.fullName }}</div>
      <n-button v-if="edit.author" @click="$var('toWaiting', true)">Отправить</n-button>
      <n-button v-if="edit.executor && !record.executor" @click="$var('acceptExecutor', true)">Ознакомлен</n-button>
      <n-button v-if="edit.client && !record.client" @click="$var('acceptClient', true)">Ознакомлен</n-button>
      <n-button v-if="done.author" @click="$var('doneAuthor', true)">Указания выполнены</n-button>
      <n-button v-if="done.executor" @click="$var('doneExecutor', true)">Указания выполнены</n-button>
      <n-button v-if="done.client" @click="$var('doneClient', true)">Указания выполнены</n-button>
    </div>
    <br />
    <n-items>
      <n-input title="Выявленные отступления от проекта и нарушения требований и правил государственных нормативов в области строительства" v-bind="$form.input('problem')" :text="!edit.author" />
      <n-input title="Указания об устранении выявленных отступлений и (или) нарушений и требуемые сроки их выполнения" v-bind="$form.input('solution')" :text="!edit.author" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.author" color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
    
    <c-modal-journal-do-sign v-if="$var('toWaiting')" @close="$var('toWaiting', false)" @submit="toWaiting" />
    <c-modal-journal-do-sign v-if="$var('acceptExecutor')" @close="$var('acceptExecutor', false)" @submit="(s) => accept('executor', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptClient')" @close="$var('acceptClient', false)" @submit="(s) => accept('client', s)" />
    <c-modal-journal-do-sign v-if="$var('doneAuthor')" @close="$var('doneAuthor', false)" @submit="(s) => doDone('author', s)" />
    <c-modal-journal-do-sign v-if="$var('doneExecutor')" @close="$var('doneExecutor', false)" @submit="(s) => doDone('executor', s)" />
    <c-modal-journal-do-sign v-if="$var('doneClient')" @close="$var('doneClient', false)" @submit="(s) => doDone('client', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        author: this.record.status === 'formed' && this.record.authorId === $app.auth.user().id,
        client: this.record.status === 'waiting' && $app.auth.can('projects_client', this.project.id) && $app.auth.can('projects_head', this.project.id) && !this.record.client,
        executor: this.record.status === 'waiting' && $app.auth.can('projects_executor', this.project.id) && $app.auth.can('projects_head', this.project.id) && !this.record.executor,
      }
    },
    done() {
      return {
        author: this.record.status === 'waiting' && this.record.authorId === $app.auth.user().id && this.record.clientDone && this.record.executorDone,
        client: this.record.status === 'waiting' && $app.auth.can('projects_client', this.project.id) && $app.auth.can('projects_head', this.project.id) && !this.record.clientDone && this.record.client,
        executor: this.record.status === 'waiting' && $app.auth.can('projects_executor', this.project.id) && $app.auth.can('projects_head', this.project.id) && !this.record.executorDone && this.record.executor,
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[client][with][participation]': null,
        'with[executor][with][participation]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    toWaiting(sign) {
      this.$var('load', true)
      $api.journals.author.records.toWaiting(this.record.id, { sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.author.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    doDone(name, sign) {
      this.$var('load', true)
      $api.journals.author.records.done(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.author.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
